/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import idx from 'idx';

import PeopleListGroupProfile from './PeopleListGroupProfile';
import GET_CLASS_PROFILE_QUERY from './queries/ClassProfileQuery.gql';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';

import type { ClassProfile_classes } from './queries/__generated__/ClassProfile.js';

type Props = {
  groupUuid: string,
  group: ?ClassProfile_classes,
  loading: boolean,
  error: errorFragmentFragment,
  onBackClicked: ?() => void,
  onUserClicked: (userId: number, organizationUuid: string) => void,
  onClose: () => void,
};

class PeopleListGroupProfileDataContainer extends React.Component<Props> {
  render() {
    const { group, loading, onBackClicked, onUserClicked, onClose } = this.props;

    if (loading) {
      return <CenteredLoadingIndicator height={50} size="small" />;
    }

    if (group) {
      return (
        <PeopleListGroupProfile
          group={group}
          onBackClicked={onBackClicked}
          onUserClicked={onUserClicked}
          onClose={onClose}
        />
      );
    }

    return null;
  }
}

const withClassProfile = graphql(GET_CLASS_PROFILE_QUERY, {
  options: ({ groupUuid }) => {
    return {
      variables: {
        classUuid: groupUuid,
      },
    };
  },
  props: ({ data }) => ({
    loading: data.loading,
    error: data.error,
    group: idx(data.classes, _ => _[0]),
  }),
});

export { PeopleListGroupProfileDataContainer };

export default withClassProfile(PeopleListGroupProfileDataContainer);
